import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities } from '../../actions';
import Logger from '../../../lib/Logger';
import { markAsReadSmsMessages } from '../smsConversations/actions';
// ACTION TYPES

export const TYPES = {
  LIST_REQUEST: 'SMS_MESSAGES/LIST_REQUEST',
  LIST_SUCCESS: 'SMS_MESSAGES/LIST_SUCCESS',
  LIST_FAILURE: 'SMS_MESSAGES/LIST_FAILURE',
  CREATE_REQUEST: 'SMS_MESSAGES/CREATE_REQUEST',
  CREATE_SUCCESS: 'SMS_MESSAGES/CREATE_SUCCESS',
  CREATE_FAILURE: 'SMS_MESSAGES/CREATE_FAILURE',
  CREATE_BULK_REQUEST: 'SMS_MESSAGES/CREATE_BULK_REQUEST',
  CREATE_BULK_SUCCESS: 'SMS_MESSAGES/CREATE_BULK_SUCCESS',
  CREATE_BULK_FAILURE: 'SMS_MESSAGES/CREATE_BULK_FAILURE',
  ADD_NEW_MESSAGE: 'SMS_MESSAGES/ADD_NEW_MESSAGE',
};

// ACTION CREATORS

export function smsMessageListRequest(
  partnershipId,
  smsConversationId,
  filter = null
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageListRequest(${partnershipId}, ${smsConversationId}, ${filter})`
  );
  return {
    type: TYPES.LIST_REQUEST,
    partnershipId: partnershipId,
    smsConversationId: smsConversationId,
    filter: filter,
  };
}

export function smsMessageListSuccess(
  partnershipId,
  smsConversationId,
  data,
  filter = null
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageListSuccess(${partnershipId}, ${smsConversationId}, %j, ${filter})`,
    data
  );
  return {
    type: TYPES.LIST_SUCCESS,
    partnershipId: partnershipId,
    smsConversationId: smsConversationId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    filter: filter,
    receivedAt: Date.now(),
  };
}
export function smsMessageListFailure(
  partnershipId,
  smsConversationId,
  error,
  filter = null
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageListFailure(${partnershipId}, ${smsConversationId}, %j, ${filter})`,
    error
  );
  return {
    type: TYPES.LIST_FAILURE,
    partnershipId: partnershipId,
    smsConversationId: smsConversationId,
    error: error,
    filter: filter,
  };
}

export function smsMessageCreateRequest(
  partnershipId,
  smsConversationId,
  data
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageCreateRequest(${partnershipId}, ${smsConversationId}, %j)`,
    data
  );
  return {
    type: TYPES.CREATE_REQUEST,
    partnershipId: partnershipId,
    smsConversationId: smsConversationId,
  };
}

export function smsMessageCreateSuccess(
  partnershipId,
  smsConversationId,
  data
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageCreateSuccess(${partnershipId}, ${smsConversationId}, %j)`,
    data
  );
  return {
    type: TYPES.CREATE_SUCCESS,
    partnershipId: partnershipId,
    smsConversationId: smsConversationId,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function smsMessageCreateFailure(
  partnershipId,
  smsConversationId,
  error
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageCreateFailure(${partnershipId}, ${smsConversationId}, %j)`,
    error
  );
  return {
    type: TYPES.CREATE_FAILURE,
    partnershipId: partnershipId,
    smsConversationId: smsConversationId,
    error: error,
  };
}

export function smsMessageBulkCreateRequest(partnershipId, data) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageBulkCreateRequest(${partnershipId}, %j)`,
    data
  );
  return {
    type: TYPES.CREATE_BULK_REQUEST,
    partnershipId: partnershipId,
  };
}

export function smsMessageBulkCreateSuccess(partnershipId, data) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageCreateSuccess(${partnershipId}, %j)`,
    data
  );
  return {
    type: TYPES.CREATE_BULK_SUCCESS,
    partnershipId: partnershipId,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function smsMessageBulkCreateFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] smsMessageCreateFailure(${partnershipId}, %j)`,
    error
  );
  return {
    type: TYPES.CREATE_BULK_FAILURE,
    partnershipId: partnershipId,
    error: error,
  };
}

// API THUNK ACTION CREATORS

export function loadSmsMessages(
  partnershipId = null,
  smsConversationId = null,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.state.smsMessages.actions] loadSmsMessages(${partnershipId}, ${smsConversationId}, ${page}, ${limit}, ${order}, ###)`
  );

  return async function (dispatch) {
    dispatch(smsMessageListRequest(partnershipId, smsConversationId, filter));

    // call API
    const response = await api.getSmsMessages(
      partnershipId,
      smsConversationId,
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get sms messages list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API sms messages list success. Partnership ID: ${partnershipId}, SMS Conversation ID: ${smsConversationId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'sms_messages']),
        [schema.smsMessage]
      );

      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(
        smsMessageListSuccess(partnershipId, smsConversationId, data, filter)
      );
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API sms messages list success [empty]. Partnership ID: ${partnershipId}, SMS Conversation ID: ${smsConversationId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(
        smsMessageListSuccess(partnershipId, smsConversationId, data, filter)
      );

      // get sms messages list failure
    } else {
      Logger.log(
        'info',
        `Get API sms messages list failure. Partnership ID: ${partnershipId}, SMS Conversation ID: ${smsConversationId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        smsMessageListFailure(
          partnershipId,
          smsConversationId,
          response.getIn(['data', 'error']),
          filter
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function createSmsMessage(
  partnershipId,
  smsConversationId,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] createSmsMessage(${partnershipId}, ${smsConversationId}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(smsMessageCreateRequest(partnershipId, smsConversationId, data));

    // call API
    const response = await api.postSmsMessage(
      partnershipId,
      smsConversationId,
      data
    );
    let success = false;

    // post sms message success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API sms message success. Partnership ID: ${partnershipId} SMS Conversation ID: ${smsConversationId}.`
      );

      const normalizedEntitySmsConversation = normalize(
        [response.getIn(['data', 'sms_conversation'])],
        [schema.smsConversation]
      );

      const normalizedEntitySmsMessage = normalize(
        [response.getIn(['data', 'sms_message'])],
        [schema.smsMessage]
      );

      const messageId = response.getIn(['data', 'sms_message', 'id']);
      const data = {
        id: messageId,
      };

      dispatch(addEntities(normalizedEntitySmsMessage));
      dispatch(addEntities(normalizedEntitySmsConversation));
      dispatch(smsMessageCreateSuccess(partnershipId, smsConversationId, data));

      if (messageId) {
        dispatch(
          markAsReadSmsMessages(partnershipId, smsConversationId, {
            last_read_sms_message_id: messageId,
          })
        );
      }

      success = true;

      // post sms message failure
    } else {
      Logger.log(
        'info',
        `POST API sms message failure. Partnership ID: ${partnershipId} SMS Conversation ID: ${smsConversationId}.`
      );
      dispatch(
        smsMessageCreateFailure(
          partnershipId,
          smsConversationId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function createBulkSmsMessages(
  partnershipId,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] createBulkSmsMessages(${partnershipId}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(smsMessageBulkCreateRequest(partnershipId, data));

    // call API
    const response = await api.postBulkSmsMessages(partnershipId, data);
    let success = false;

    // post bulk sms message success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `POST API sms message success. Partnership ID: ${partnershipId}.`
      );

      dispatch(smsMessageBulkCreateSuccess(partnershipId, data));

      success = true;

      // post bulk sms message failure
    } else {
      Logger.log(
        'info',
        `POST API sms message failure. Partnership ID: ${partnershipId}.`
      );
      dispatch(
        smsMessageCreateFailure(
          partnershipId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function addNewSmsMessage(partnershipId, smsConversationId, smsMessage) {
  Logger.log(
    'debug',
    `[state.smsMessages.actions] addNewSmsMessage(${partnershipId}, ${smsConversationId}, %j)`,
    smsMessage
  );

  return function (dispatch) {
    const normalizedMessage = normalize(smsMessage, schema.smsMessage);
    dispatch(addEntities(normalizedMessage));

    return dispatch({
      type: TYPES.ADD_NEW_MESSAGE,
      partnershipId,
      smsConversationId,
      messageId: smsMessage.id,
      receivedAt: Date.now(),
    });
  };
}

Logger.log('silly', `state.smsMessages.actions loaded.`);
